import type { GatewayRanking } from 'commonTypes/api/gatewayRanking';

export const mergeBlockFF = (
  reduceBlockFF: GatewayRanking.RankingFeatureFlagsConfig | undefined,
  flowBlockFF: Partial<Pick<GatewayRanking.RankingFeatureFlagsConfig, 'isUseMpl'>> = {},
): GatewayRanking.RankingFeatureFlagsConfig | undefined => {
  if (!flowBlockFF) {
    return reduceBlockFF;
  }

  if (!reduceBlockFF) {
    return flowBlockFF;
  }

  return {
    ...reduceBlockFF,
    ...flowBlockFF,
  };
};
